import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {CultureComparison} from './CultureComparison';
import {CultureFitHeader, MiniCultureType} from './CultureFitHeader/CultureFitHeader';
import {LockedCultureTypeBanner} from '../../../../../components/Banner/LockedCultureTypeBanner/LockedCultureTypeBanner';
import {CultureHouseCard} from '../../../../../components/CultureHouseCard/CultureHouseCard';
import {PageSection} from '../../../../../components/PageSection/PageSection';
import {LanguageContext} from '../../../../../contexts/LanguageContext/LanguageContext';
import {CultureHouseElement} from '../../../../company/culture/dashboard/types/CultureHouseTypes';
import {Match, Pillar} from '../../../dashboard/types/ApplicantMatchesTypes';

interface Props {
  match: Match;
  applicantCultureType: MiniCultureType | null;
  applicantProfileImg: string;
  siblingOffset: number;
}
export const CultureFitDetails = ({match, applicantCultureType, applicantProfileImg, siblingOffset}: Props) => {
  const lang = useContext(LanguageContext);
  const {t} = useTranslation();
  const pillars = match.company.pillars;
  const companyCultureType = match.company.cultureType;

  const transformToCultureHouseElement = (pillar: Pillar): Omit<CultureHouseElement, 'surveyResults'> => ({
    resourceId: pillar.resourceId,
    key: pillar.identifier,
    pillarDescription: pillar.description,
    pillarTitle: pillar.name,
  });

  return (
    <Grid>
      <PageSection bgColor='transparent' sx={{paddingTop: '80px', paddingBottom: '80px'}} topPosition={siblingOffset}>
        <Grid>
          <CultureFitHeader
            companyLogo={match.company.logoUrl}
            companyCultureType={{name: companyCultureType.name[lang], url: companyCultureType.imageUrl || ''}}
            applicantCultureType={applicantCultureType}
            applicantProfileImg={applicantProfileImg || ''}
            culturalFitScore={match.culturalFitScore}
          />
        </Grid>
        {applicantCultureType ? (
          <>
            <Grid>
              <CultureComparison
                cultureMatchItems={match.items}
                companyName={match.company.name}
                applicantName={t('applicantDashboard.matchDetailsView.cultureFitDetails.me')}
              />
            </Grid>
            <Grid>
              <Typography variant='h2' paddingBottom='16px'>
                {t('companyCultureDashboard.cultureHouse.header')}
              </Typography>
              <Grid container gap={'32px'}>
                {pillars.map((pillar) => (
                  <CultureHouseCard
                    key={`pillar-${pillar.resourceId}`}
                    cultureHouseElement={transformToCultureHouseElement(pillar)}
                  />
                ))}
              </Grid>
            </Grid>
          </>
        ) : (
          <LockedCultureTypeBanner />
        )}
      </PageSection>
    </Grid>
  );
};
